/**
 * SWUpdateToast — shows a reload prompt when a new service worker is available.
 * Listens to the 'controllerchange' event on navigator.serviceWorker.
 * Prevents stale-cache bugs after deployment.
 */
import { useState, useEffect } from 'react'
import { RefreshCw } from 'lucide-react'
import { useT } from '@/i18n'

export function SWUpdateToast() {
  const t = useT()
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    const reloading = false
    const handler = () => {
      if (reloading) return
      setShow(true)
    }

    navigator.serviceWorker.addEventListener('controllerchange', handler)
    return () => navigator.serviceWorker.removeEventListener('controllerchange', handler)
  }, [])

  if (!show) return null

  const handleReload = () => {
    window.location.reload()
  }

  return (
    <div
      className="fixed top-4 left-1/2 -translate-x-1/2 z-[300] animate-in slide-in-from-top"
      style={{ maxWidth: 'calc(100vw - 32px)', width: '360px' }}
    >
      <div
        className="flex items-center gap-3 px-4 py-3 rounded-2xl bg-[var(--y-surface-primary)] border border-[var(--y-border)]"
        style={{ boxShadow: 'var(--y-shadow-fab)' }}
      >
        <RefreshCw className="w-4 h-4 text-[var(--y-accent)] flex-shrink-0" strokeWidth={2} />
        <p className="flex-1 text-sm text-[var(--y-text-primary)]">
          {t('navigation.appearance.updateAvailable')}
        </p>
        <button
          onClick={handleReload}
          className="px-3 py-1.5 rounded-lg flex-shrink-0 text-xs font-semibold"
          style={{
            background: 'var(--y-accent)',
            color: 'var(--y-accent-text)',
          }}
        >
          {t('navigation.appearance.reload')}
        </button>
      </div>
    </div>
  )
}
